<template>
  <v-card class="pa-0" :height="screenHeight">
    <div :style="{
      border: '#deb900 2px solid',
      margin: '5px',
      'border-radius': 0,
      'font-family': 'Roboto,sans-serif',
      'margin-top': logoImageUrl ? '50px' : '25px',
    }">
      <div style="border: #deb900 6px solid; margin: 3px; padding: 4px; border-radius: 0;">

        <div style="">
          <template v-if="logoImageUrl">
            <div style="position:relative; top: -40px; text-align: center; height: 5vw">
              <!--            <img src="/53167c02ebd342d69f9df737affb5898.gif" alt="Logo" style="max-width: 25%; max-height: 16vw;">-->
              <img :src="logoImageUrl" alt="Logo" style="max-width: 25%">
            </div>
          </template>
          <div style="text-align: center; color: #deb900; font-size: 36px;">NOW SERVING</div>
          <div style="text-align: center; font-size: 18px;">Number will not be called in sequence</div>
        </div>

        <table style="width: 100%; text-align: center; font-weight: bold; line-height: 1; margin-top: 20px;">
          <tr style="height: 42px;">
            <td style="border-right: white 2px solid; width: 26%"></td>
            <td style="border-right: white 2px solid; background: #deb900; width: 37%;">Current</td>
            <td style="width: 37%; background: #696969; color: white; ">Groups in Queue</td>
          </tr>

          <template v-for="queue in queues">
            <tr style="height: 68px;">
              <td style="border-right: white 2px solid; border-top: white 2px solid; background: #deb900; font-size: 18px;">
                {{ queue.name }}
              </td>
              <td style="border-right: white 2px solid; border-top: white 2px solid; background: #e8debf; font-size: 66px;">
                {{ queueListMapping.hasOwnProperty(queue.id) && queueListMapping[queue.id][0] ? queueListMapping[queue.id][0].queue_no : '' }}
              </td>
              <td style="border-top: white 2px solid; background: #ececec; font-size: 66px;">
                {{ queueListMapping.hasOwnProperty(queue.id) && queueListMapping[queue.id][0] ? queueListMapping[queue.id][0].queue_remaining : '' }}
              </td>
            </tr>
          </template>

          <!--          <tr style="height: 68px;">-->
          <!--            <td style="border-right: white 2px solid; border-top: white 2px solid; background: #deb900; font-size: 18px;">-->
          <!--              1 to 2 Pax-->
          <!--            </td>-->
          <!--            <td style="border-right: white 2px solid; border-top: white 2px solid; background: #e8debf; font-size: 66px;">-->
          <!--              A108-->
          <!--            </td>-->
          <!--            <td style="border-top: white 2px solid; background: #ececec; font-size: 66px;">1</td>-->
          <!--          </tr>-->

        </table>
      </div>
    </div>
  </v-card>
</template>

<script>
import axios from "axios";

export default {
  data: () => {
    return {
      previousNos: [],
      callingNo: [],
      queuesData: null,
      queueListMapping: {},
    };
  },
  props: ['outlet', 'fulldisplay', 'fontSize', 'logoImageUrl'],
  computed: {
    screenHeight() {
      if (this.fulldisplay === true && !this.outlet.display_missed) {
        return this.outlet.page_rotation === 0 ? window.innerHeight : window.innerWidth;
      } else {
        return this.outlet.display_missed ? '90vh' : '100%'
      }
    },
    queues() {
      return this.queuesData !== null ? this.queuesData : [];
    }
  },
  watch: {
    callingNo: function (newVal, oldVal) {
      if (oldVal.length !== 0) {
        this.previousNos.push(oldVal);
      }
      if (this.previousNos.length === 5) {
        this.previousNos.shift();
      }
    },
    queues(value) {
      console.log('queues watch running.');

      for (let i = 0; i < value.length; i++) {
        let queue = value[i];
        this.$set(this.queueListMapping, queue.id, []);
      }

      this.fetchQueueList();
    }
  },
  methods: {
    playSound() {
      let bell = this.outlet.audio ? new Audio('/storage' + this.outlet.audio) : new Audio('/storage/audios/default.mp3');
      bell.play();
    },
    fetchQueues() {
      axios.get(`/api/outlet_display/${this.outlet.slug}/active_queues`)
          .then((response) => {
            console.log('active_queue response');
            console.log(response);
            this.queuesData = response.data;
            console.log(response.data);
          })
          .catch(error => {
            console.log('active_queue error');
            console.log(error);
          });
    },
    fetchQueueList() {
      console.log('fetchQueueList')
      for (let i = 0; i < this.queues.length; i++) {
        let queue = this.queues[i];

        axios.get(`/api/outlet_display/${this.outlet.slug}/queues/${queue.id}/queue_list`)
            .then(response => {
              if (!this.queueListMapping.hasOwnProperty(queue.id)) {
                this.$set(this.queueListMapping, queue.id, []);
              }

              if (!Array.isArray(response.data)) {
                return;
              }

              for (let j = 0; j < response.data.length; j++) {
                let queueList = response.data[j];
                this.queueListMapping[queue.id].push({
                  queue_no: queueList.queue_no,
                  queue_remaining: queueList.queue_remaining,
                });
              }
            })
            .catch(error => {
              console.log('active_queue error');
              console.log(error);
            });
      }
    }
  },
  created: function () {
    this.fetchQueues();

    Echo.channel('tvcall-channel')
        .listen('.QueueNumberReceived', (e) => {
          console.log('----------e----------');
          console.log(e);
          console.log('----------e----------');

          if (!(e.outlet_id === this.outlet.id && e.type === 'queue')) {
            return;
          }

          if (!this.queueListMapping.hasOwnProperty(e.queue_id)) {
            this.$set(this.queueListMapping, e.queue_id, []);
          }
          this.queueListMapping[e.queue_id].unshift({
            queue_no: e.queue_number,
            queue_remaining: e.queue_remaining,
          });

          this.playSound();
          // make queue # blinks
          $('.callingNo').each(function () {
            var elem = $(this);
            // count the blinks
            var count = 1;
            var intervalId = setInterval(function () {
              if (elem.css('visibility') == 'hidden') {
                elem.css('visibility', 'visible');
                // increment counter when showing to count # of blinks and stop when visible
                if (count++ === 4) {
                  clearInterval(intervalId);
                }
              } else {
                elem.css('visibility', 'hidden');
              }
            }, 400);
          });
        })

    console.log('created.')
  }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/CallingNumber2.vue